var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / info-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 1.0249C3.78334 1.0249 1.1665 3.64174 1.1665 6.85824C1.1665 10.0747 3.78334 12.6916 6.99984 12.6916C10.2163 12.6916 12.8332 10.0747 12.8332 6.85824C12.8332 3.64174 10.2163 1.0249 6.99984 1.0249ZM6.99984 11.5249C4.42675 11.5249 2.33317 9.43132 2.33317 6.85824C2.33317 4.28515 4.42675 2.19157 6.99984 2.19157C9.57292 2.19157 11.6665 4.28515 11.6665 6.85824C11.6665 9.43132 9.57292 11.5249 6.99984 11.5249Z",
    fill: "#1B1A1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4165 6.85824C6.4165 6.53607 6.67767 6.2749 6.99984 6.2749C7.322 6.2749 7.58317 6.53607 7.58317 6.85824V9.19157C7.58317 9.51374 7.322 9.7749 6.99984 9.7749C6.67767 9.7749 6.4165 9.51374 6.4165 9.19157V6.85824ZM6.4165 4.5249C6.4165 4.20274 6.67767 3.94157 6.99984 3.94157C7.322 3.94157 7.58317 4.20274 7.58317 4.5249C7.58317 4.84707 7.322 5.10824 6.99984 5.10824C6.67767 5.10824 6.4165 4.84707 6.4165 4.5249Z",
    fill: "#1B1A1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleIcon);
export default __webpack_public_path__ + "static/media/info-circle-icon.b511b3c47e998333865c88c3c1819095.svg";
export { ForwardRef as ReactComponent };